import { getFirstPossibleRoute } from '@/router/utils/getFirstPossibleRoute'
import { type Route } from '@/types/route'

export const teamsChildrenRoutes = [
  {
    path: '',
    name: 'team-list' as const,
    component: () => import('@/views/Teams/TeamsView.vue'),
    meta: {
      title: 'Teams',
      tab: 'administration',
      permissions: ['teams.view_team']
    }
  }
] satisfies Route[]

export const teamsRoutes = [
  {
    path: 'teams',
    name: 'teams' as const,
    component: () => import('@/views/Layouts/RouterView.vue'),
    meta: {
      title: 'Teams',
      icon: 'team',
      tab: 'administration'
    },
    redirect: () => getFirstPossibleRoute(teamsChildrenRoutes),
    children: teamsChildrenRoutes
  }
] satisfies Route[]
